import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgCheckboxChecked = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M18 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3m.38 6.56-7.56 7.56a.42.42 0 0 1-.28.12.45.45 0 0 1-.29-.12L6.11 13a.41.41 0 0 1 0-.56l.89-.91a.4.4 0 0 1 .28-.12.45.45 0 0 1 .29.12l2.69 2.7a.45.45 0 0 0 .29.12.42.42 0 0 0 .28-.12l6.12-6.11a.39.39 0 0 1 .56 0l.88.87a.4.4 0 0 1-.01.57"
    }));
export default SvgCheckboxChecked;
